<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="370"
    >
      <v-card>
        <v-card-title class="justify-center display-1">{{ $vuetify.lang.t('$vuetify.infoModalCheckInDetail.infoWork')}}
            <div class="pa-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path fill="green" d="m10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m-7-6A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/></svg>
            </div>
        </v-card-title>

        <v-card-text class="text-center" style="info-content" v-html="msg" />

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="submitBtn()"
          >
            {{ $vuetify.lang.t('$vuetify.infoModalCheckInDetail.confirm')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    data () {
        return {
            dialog: false
        }
    },
    props: {
        msg: {
            type: String,
            default: null
        }
    },
    methods: {
        submitBtn () {
            this.$emit('ok-submit')
            this.dialog = false
        }
    }
}
</script>

<style>
.info-content {
    font-size: 1rem !important;
    line-height: 32px;
    width: max-content;
    text-align: center;
}
</style>
